import { SearchDocumentsDto } from '../../../services/dtos/securities/searchDocuments.dto';
import { groupToMap } from '../../../utils/groupToMap';

/**
 * Groups documents into root group and subgroups. Root group is grouped by associated_report_id or report_id if former is not present, where subgroups by report_id.
 * Result of grouping ends up with array of groups, where each group will have n>=1 of groups inside. First array inside a group denotes
 * root group where any consecutive arrays will be interpreted as subgroups. e.g. [[d1],[d2]] should be interpreted as outer array
 * representing one whole group where d1 is inside root group ( first array is always considered root ) and d2 is in subgroup.
 * The end result will be an array of such data structures each representing its own group of documents.
 */
export const groupDocuments = <DocumentType extends SearchDocumentsDto>(
  documents: DocumentType[]
): DocumentType[][][] => {
  const documentsGroupMap = groupToMap(documents, (document) => {
    // There is a data bug in some environments where some documents return associated_report_id as 0 which is invalid value hence
    // why we convert associated_report_id to boolean value before returning it to check if it actually exists
    const hasAssociatedReportId = Boolean(document.associated_report_id);

    return hasAssociatedReportId ? document.associated_report_id! : document.report_id;
  });
  const documentsSubGroups = Array.from(documentsGroupMap.values()).reduce<DocumentType[][][]>((acc, documents) => {
    const subGroups = groupToMap(documents, (document) => document.report_id);

    return acc.concat([Array.from(subGroups.values())]);
  }, []);

  return documentsSubGroups;
};
